var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogoGlyph = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 296,
  height: 296,
  fill: "none",
  viewBox: "0 0 296 296"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M145.329 252h5.297l8.546-73.03c.579-6.201 4.719-8.878 11.484-6.201l122.673 51.125 2.671-4.728-109.097-63.26c-6.499-3.837-6.499-10.35 0-14.187L296 77.835l-2.671-5.042-122.628 51.17c-5.876 2.365-10.594-.312-11.484-6.781L150.671 45h-5.297l-8.546 72.138c-.891 6.513-5.609 9.145-11.484 6.781L2.671 72.793 0 77.834l109.097 63.885c6.499 3.837 6.499 10.35 0 14.187L0 219.166l2.67 4.728 122.629-51.17c6.766-2.676 10.906 0 11.484 6.201L145.329 252Z"
})));
export default SvgLogoGlyph;